import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import * as Constants from "../../constants/urls";
import axios from "axios";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const M = () => {
    const ProductUrl = Constants.oldAdminUrl + "/products/admin";
    const PackUrl = Constants.oldAdminUrl + "/pack/admin";
    const acceptedtUrl = Constants.oldAdminUrl + "/newPrefactor?tab=accepted";
    const oldPackStockUrl = Constants.oldAdminUrl + "/newPrefactor/oldPackStock";
    const addtopackUrl = Constants.oldAdminUrl + "/newPrefactor?tab=addtopack";
    const pickUrl = Constants.oldAdminUrl + "/newPrefactor/pick";
    const anbargardaniUrl = Constants.siteUrl + "/admin/anbargardani";
    const [cookies, setCookie, removeCookie] = useCookies();
    const [login, setLogin] = useState(false);
    function getAnbargardani() {
        const url = Constants.apiUrl + "/api/me";
        axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + cookies.user_server_token,
            }
        }).then((r) => {
            setLogin(true);

        }).catch((e) => {
            setLogin(false);
            window.location = "403";


        });
    }

    useEffect(() => {
        getAnbargardani();
    }, [])

    return (<>
        {login ? <>
            <Breadcrumb  />
            
            <div className="container">
                <div className="row">
                    <a href={ProductUrl} className="btn btn-primary col-sm-12 my-2 py-4" target="_blank">
                        محصولات
                    </a>
                    <a href={PackUrl} className="btn btn-primary col-sm-12 my-2 py-4 " target="_blank">
                        بسته ها
                    </a>
                    <a href={acceptedtUrl} className="btn btn-primary col-sm-12 my-2 py-4 " target="_blank">
                        پیش فاکتور تایید شده
                    </a>
                    <a href={addtopackUrl} className="btn btn-primary col-sm-12 my-2 py-4" target="_blank">
                        پیش فاکتور / موجودی پک
                    </a>

                    <a href={oldPackStockUrl} className="btn btn-primary col-sm-12 my-2 py-4" target="_blank">
                        ثبت موجودی پک
                    </a>
                    <a href={pickUrl} className="btn btn-primary col-sm-12 my-2 py-4" target="_blank">
                        چیدن
                    </a>
                    <a href={anbargardaniUrl} className="btn btn-primary col-sm-12 my-2 py-4" target="_blank">
                        انبارگردانی
                    </a>
                </div>
            </div>
        </>
            : ""}

    </>)

}
export default M;